export default (state = { expanded: false, mapData: null }, { type, payload }) => {
  switch (type) {
    case 'HUNT_PLANNER_RIGHT_MENU_OPEN':
      return {
        expanded: true,
        mapData: payload.mapData ? payload.mapData : null,
        coordinates: payload.coordinates ? payload.coordinates : null,
        unitDetails: payload.unitDetails ? payload.unitDetails : null,
      }
    case 'HUNT_PLANNER_RIGHT_MENU_CLOSE':
      return {
        expanded: false,
        mapData: null,
        coordinates: null,
        unitDetails: null
      }
    case 'LOGOUT':
      return {
        expanded: false,
      }
    default:
      return state
  }
}